import { FC } from 'react';

export const ExclamationMarkDouble: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<rect x="6" y="2" width="4" height="12" rx="1" fill="currentColor" />
		<circle cx="8" cy="18" r="2.5" fill="currentColor" />
		<rect x="16" y="2" width="4" height="12" rx="1" fill="currentColor" />
		<circle cx="18" cy="18" r="2.5" fill="currentColor" />
	</svg>
);
